import axios from "./axios";
import * as Requests from "./requests";

export const getOrderingPortalLinkApi = (token: string) => {
  return axios.get(Requests.orderingPortalLinkURL, {
    headers: {
      token,
    },
  });
};
